import { useState } from 'react';
import { AdminSidebar } from '@/components/sidebars';

export function AdminLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return <AdminSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />;
}
